// extracted by mini-css-extract-plugin
module.exports =  {"toggle-container":"toggle-container-LD19U","toggle":"toggle-c9IYf"};